<template>
  <div class="forget-password-container">
    <h3>{{ t('loginRegister.forgetPasswordTitle') }}</h3>
    <label class="input-label">
      {{ t('loginRegister.username') }}
      <span style="color:red;margin-left:2px;">*</span>
    </label>
    <input
      v-model="username"
      type="text"
      :placeholder="t('loginRegister.usernamePlaceholder')"
      class="input"
    />

    <label class="input-label">
      {{ t('loginRegister.emailVerify') }}
      <span style="color:red;margin-left:2px;">*</span>
    </label>
    <input
      v-model="email"
      type="email"
      :placeholder="t('loginRegister.emailPlaceholder')"
      class="input"
      @input="handleEmailInput"
      @focus="emailFocused = true"
    />
    <div v-if="emailError" class="error-tip">
      {{ t('loginRegister.emailFormatError') }}
    </div>

    <button
      class="btn-submit"
      :disabled="!canSubmit"
      :class="{ disabled: !canSubmit }"
      @click="submit"
    >{{ t('loginRegister.submit') }}</button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const username = ref('')
const email = ref('')
const emailError = ref(false)
const emailFocused = ref(false)

function handleEmailInput() {
  if (emailFocused.value && email.value) {
    validateEmail()
  } else {
    emailError.value = false
  }
}

function validateEmail() {
  emailError.value = !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email.value)
}

const canSubmit = computed(() => {
  return username.value && email.value && !emailError.value
})

function submit() {
  validateEmail()
  if (!canSubmit.value) {
    return
  }
  // 这里可以添加找回密码的逻辑
  alert(t('loginRegister.resetMailSent'))
}
</script>

<style scoped>
.forget-password-container {
  padding: 32px 24px 24px 24px;
  min-width: 320px;
  box-shadow: none; /* 移除阴影 */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: none; /* 移除边框 */
}
.input-label {
  font-size: 14px;
  margin-bottom: 4px;
  display: block;
}
.input {
  margin-bottom: 10px;
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.error-tip {
  color: red;
  font-size: 12px;
  margin-bottom: 10px;
}
.btn-submit {
  background-color: #fb6e01;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 0;
  font-weight: bold;
  cursor: pointer;
  width: 120px;
  align-self: flex-start;
  transition: background 0.2s;
}
.btn-submit.disabled,
.btn-submit:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  color: #fff;
}
.btn-submit:hover:enabled {
  background-color: #e05602;
}
</style>
